import styled from 'styled-components';

export const StyledFlipOnScrollImage = styled.div`
  position: relative;
  perspective: 1000px;

  .images-container {
    width: 100%;
    height: 100%;
    position: relative;

    .front-image {
      position: absolute;
      width: 100%;
      height: 100%;
      backface-visibility: hidden;
    }

    .back-image {
      position: absolute;
      width: 100%;
      height: 100%;
      backface-visibility: hidden;
      transform: rotateY(180deg);
    }

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
`;
